<mat-select [formControl]="skjemakontroll"
            [compareWith]="erValgt"
            panelClass="velg-tema--alternativer"
            [placeholder]="placeholder"
            panelWidth="200px"
            class="e2e-dag"
            data-testid="dag"
            #dagvelger>
  <mat-select-trigger>
    <span class="dag">{{ "Dag {dag}"|translate: {dag: skjemakontroll.value+1} }}</span>
    @if (skjemakontroll.value) {
      <span class="dato">({{ valgtDagSomDato() | plaindate:{weekday:"short"} }})</span>
    }
  </mat-select-trigger>
  @for (dag of dagerVedFlerdagsmoeter; track dag.verdi) {
    <mat-option [value]="dag.verdi">
      <div>{{ "Dag {dag}"|translate: {dag: dag.verdi+1} }}</div>
      <div class="dato">{{ dag.dato | plaindate:'long' }}</div>
    </mat-option>
  }
</mat-select>
